// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2stXq","title":"FrontImage_title__3bowj"};